module.exports = __webpack_public_path__ + "static/media/responsive-saphir.acd11167.png";